import React, { useState } from 'react';
import './playgroundPage.css';

export default function PlaygroundPage(props) {
  return ResizablePanels(props);
  //return DefaultPlayground(props);
}

function ResizablePanels(props) {
  const [isDragging, setIsDragging] = useState(false);
  const [dragIndex, setDragIndex] = useState(0);
  const [initialX, setInitialX] = useState(0);
  const [deltaX, setDeltaX] = useState(0);
  const [widths, setWidths] = useState([150, 150, 150, 150]);
  const minWidths = [120, 120, 120, 120];
  const maxWidths = [300, 400, 400, 800];

  const translateDelta = (delta) => {
    return dragIndex > 1 ? -delta : delta;
  };

  const startResize = (event, index) => {
    setIsDragging(true);
    setDragIndex(index);
    setInitialX(event.clientX);
    setDeltaX(0);
  };

  const stopResize = () => {
    if (isDragging) {
      const newWidths = [...widths];
      newWidths[dragIndex] = widths[dragIndex] + translateDelta(deltaX);
      if (newWidths[dragIndex] > maxWidths[dragIndex]) {
        newWidths[dragIndex] = maxWidths[dragIndex];
      }
      if (newWidths[dragIndex] < minWidths[dragIndex]) {
        newWidths[dragIndex] = minWidths[dragIndex];
      }
      setWidths(newWidths);
      setIsDragging(false);
    }
  };

  const resizePanel = (event) => {
    if (isDragging) {
      let newDelta = event.clientX - initialX;
      const newWidth = widths[dragIndex] + translateDelta(newDelta);
      if (newWidth > maxWidths[dragIndex]) {
        newDelta = translateDelta(maxWidths[dragIndex] - widths[dragIndex]);
      }
      if (newWidth < minWidths[dragIndex]) {
        newDelta = translateDelta(minWidths[dragIndex] - widths[dragIndex]);
      }
      setDeltaX(newDelta);
    }
  };

  const getPanelStyle = (index) => {
    //to make resize happen dynamically
    if (isDragging && dragIndex === index) {
      return { width: widths[index] + translateDelta(deltaX) };
    }
    return { width: widths[index] };
  };

  const getResizerStyle = (index) => {
    //to make resize happen at end of event
    /*if (isDragging && dragIndex === index) {
      return { left: deltaX };
    }*/
    return {};
  };

  return (
    <div className='board-layout' onMouseUp={stopResize} onMouseMove={(e) => resizePanel(e)}>
      <div className='board-left' style={getPanelStyle(0)}>
        Panel 1
      </div>
      <div className='resizer' style={getResizerStyle(0)} onMouseDown={(e) => startResize(e, 0)}></div>
      <div className='board-middle-left' style={getPanelStyle(1)}>
        Panel 2
      </div>
      <div className='resizer' style={getResizerStyle(1)} onMouseDown={(e) => startResize(e, 1)}></div>
      <div className='board-main'>
        Panel 3
      </div>
      <div className='resizer' style={getResizerStyle(2)} onMouseDown={(e) => startResize(e, 2)}></div>
      <div className='board-middle-right' style={getPanelStyle(2)}>
        Panel 4
      </div>
      <div className='resizer' style={getResizerStyle(3)} onMouseDown={(e) => startResize(e, 3)}></div>
      <div className='board-right' style={getPanelStyle(3)}>
        Panel 5
      </div>
    </div>
  );
}

function DefaultPlayground(props) {
  return (
    <div className='row justify-content-center mx-0 mt-4'>
      <div className='col-md-12 col-xl-10'>
        <div className='playground'>

          <span></span>

        </div>
      </div>
    </div>
  );
}